import 'prometheus.aaa.scss';
import 'prometheus.modern.scss';

import './theme.aaa.scss';
import './theme.modern.scss';


import { registerDocumentClickBubblingOnTop } from "@itslearning/atlas/frames/IframeClickEventHelper";
import { postMessage } from "@itslearning/atlas/network/postMessage";

import { get } from "svelte/store";

import { loadLangs } from './lang/loader';

import App from "./lib/App/App.svelte";

import { backLink, planData } from "@its-ui/planner-common/logic/planPage/stores";
import { loadPlan } from "@its-ui/planner-common/helpers/loadPlansHelper";
import { newPlanDefaults } from "@its-ui/planner-common/helpers/planDefaults";
import i18n from "@its-ui/planner-common/i18n";
import config from "@its-ui/planner-common/config";
import { backLinkDestinations } from "@its-ui/planner-common/constants";
import { getPlan, getTopic } from "@its-ui/planner-common/api";
import "@its-ui/planner-common/helpers/CommonFunctions.js";
import "@its-ui/planner-common/helpers/TextEditor.js";

await loadLangs(config.lang);

registerDocumentClickBubblingOnTop();

// @ts-ignore
const topPage = window.itslTop || window.top;

// If plans is opened in an itslearning iFrame set the selected menu item and collapse the tree menu
if (topPage) {
    if (typeof topPage.hideContentAreaTreeMenu === "function") {
        topPage.hideContentAreaTreeMenu();
    }

    if (typeof topPage.SelectCurrentNavigationItem === "function") {
        topPage.SelectCurrentNavigationItem("planner");
    }
}

parentPostMessage("askIfCustomTreeLinkNavigationRequired");
parentPostMessage("expandContentAreaFrame");
parentPostMessage("setIframeDefaultHeight");

window.onunload = resetFullscreenIframe;
// @ts-ignore
document.pagehide = resetFullscreenIframe;

parentPostMessage("setIFrameTitleMessage", { iFrameTitle: i18n.title });

const backDestination =
    parseInt(new URLSearchParams(window.location.search).get("BackDestination")) || 0;

let label = config.backLink.label;

// On topic pages the name of the topic is not knows yet so replace the placeholder with the topic term
if (backDestination === backLinkDestinations.topic) {
    label = label.replace("{0}", config.topicName);
}

backLink.set({ label, url: config.backLink.url, target: config.backLink.target, destination: config.backLink.destination });

// Get the mount point for the App
const target = document.getElementById("plans");

const app = new App({ target });

if (config.newPlan) {
    planData.set({ loading: true });

    initializeNewPlan().then(plan => loadPlan(planData, config.publicAccessKey, plan.id));
} else {
    loadPlan(planData, config.publicAccessKey, config.planId).then(() => {
        if (backDestination === backLinkDestinations.topic) {
            const { plan } = get(planData);

            if (plan.topic) {
                backLink.update(bl => {
                    bl.label = config.backLink.label.replace("{0}", plan.topic.name);

                    return bl;
                });
            }
        }
    });
}

// This function is called from 'GetRefreshPlannerResourcesCellScript' in PlannerUtils.cs and 'AddRefreshPlannerCellScript' in XHTML.cpp.
// It combines the old and the new planner to refresh the plan after adding an element.
// @ts-ignore
window.refreshResources = refreshPlanResources;
// @ts-ignore
window.multipleFilesUploadedToResourcesCell = multipleFilesUploadedToPlan;
// @ts-ignore
window.redirectToPlanUrl = redirectToPlanUrl;

function multipleFilesUploadedToPlan() {
    getPlan().then(updatePlan => {
        planData.update(data => {
            planData.update(data => {
                data.plan.elements = updatePlan.elements;
                data.isNewFilesUploadStarted = true;

                return data;
            });

            return data;
        });
    });
}

function parentPostMessage(name, data = {}) {
    postMessage({ messageName: name, ...data });
}

function resetFullscreenIframe() {
    parentPostMessage("collapseContentAreaFrame");
    parentPostMessage("setIframeDefaultHeight");
}

export function refreshPlanResources(planId ) {
    getPlan().then(updatePlan => {
        planData.update(data => {
            data.plan.elements = updatePlan.elements;
            data.isNewFilesUploadStarted = true;

            return data;
        });
    });
}

export function redirectToPlanUrl(url) {
    window.location.href = url;
}

async function initializeNewPlan() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const topicIdParam = urlParams.get("topicId") || urlParams.get("TopicId");
    const planIdParam = urlParams.get("pendingPlanId");

    let topicId;
    let topic;
    let newPlanId;

    try {
        topicId = parseInt(topicIdParam);
    } catch (e) {
        console.error(e);
    }

    try {
        newPlanId = parseInt(planIdParam);
    } catch {
        // do nothing
    }

    if (topicId) {
        topic = await getTopic(topicId);
    }

    const id = newPlanId;

    return { ...newPlanDefaults, topic, id };
}

export default app;
